import ScrollableSection from '@components/v2/layout/ScrollableSection/ScrollableSection';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { ListScreenTestIds } from '../../../../../utils/testIds/listScreen.testIds';
import { useListScreenContext } from '../contexts/ListScreen.context';

interface ListScreenBodyProps {
  filterBar?: ReactNode;
  scrollRef?: (node: HTMLElement | null) => void;
  children: (scrollParent: HTMLElement | null) => ReactNode;
}

export function ListScreenBody({ filterBar, scrollRef, children }: ListScreenBodyProps) {
  const { scrollNode, setScrollNode, triggerRef } = useListScreenContext();

  return (
    <ScrollableSection
      ref={(node: HTMLDivElement | null) => {
        setScrollNode(node);
        scrollRef?.(node);
      }}
      testId={ListScreenTestIds.SCROLL_CONTAINER}
      sx={{ display: 'flex', flexDirection: 'column' }}
    >
      {filterBar && <Box sx={{ mb: 2, '&:empty': { display: 'none' } }}>{filterBar}</Box>}
      <Box ref={triggerRef} />
      <Box sx={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column' }}>
        {children(scrollNode)}
      </Box>
    </ScrollableSection>
  );
}
